// @ts-nocheck -- verbatim TAPP payroll UI compatibility boundary
import { Skeleton as HeroSkeleton } from "@heroui/react";
import { clsx } from "clsx";
import type { ComponentProps } from "react";

export type SkeletonProps = ComponentProps<typeof HeroSkeleton.Root>;

export function Skeleton({
  animationType = "shimmer",
  className,
  ...props
}: SkeletonProps) {
  return (
    <HeroSkeleton.Root
      animationType={animationType}
      className={clsx("tapp-skeleton", className)}
      {...props}
    />
  );
}
